import React from "react";
import { useIntl } from "react-intl";
import { Form, Input, Icon, Row, Col } from "antd";

import TooltipButton from "../../app/generic/tooltipButton";

function ReferenceForm({
  form,
  detail,
  formItemLayout,
  initialValue,
  showAll,
  onShowAllPanels,
  onHideAllPanels,
}) {
  const intl = useIntl();
  const { getFieldDecorator } = form;

  return (
    <Form {...formItemLayout}>
      <Row gutter={[0, 50]}>
        <Col sm={10} xl={6}>
          {getFieldDecorator("reference", {
            ...{ initialValue },
          })(
            <Input
              allowClear
              disabled={detail}
              placeholder={intl.formatMessage({
                id: "consignment.reference",
                defaultMessage: "zákaznická reference",
              })}
              prefix={<Icon type="form" className="form-input-icon" />}
            />
          )}
        </Col>
        <Col sm={14} xl={18}>
          <Row type="flex" justify="end">
            <TooltipButton
              text={
                showAll
                  ? intl.formatMessage({
                      id: "messages.showAll",
                      defaultMessage: "Rozbalit vše",
                    })
                  : intl.formatMessage({
                      id: "messages.hideAll",
                      defaultMessage: "Sbalit vše",
                    })
              }
              onClick={showAll ? onShowAllPanels : onHideAllPanels}
            />
          </Row>
        </Col>
      </Row>
    </Form>
  );
}

export default Form.create()(ReferenceForm);
